<style scoped>
.payment-information {
    display: flex;
    /* align-items: center; */
    width: 100%;
    margin-top: 30px;
}

.pay-item {
    display: flex;
    align-items: center;
    width: 90%;
    margin-top: 10px;
    margin-bottom: 10px;
}

.pay-name {
    width: 100px;
    line-height: 32px;
    text-align: right;
    flex-shrink: 0;
    margin-right: 10px;
}

.pay-left {
    width: 100%;
    padding: 20px;
}

.pay-right {
    width: 10%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.el-icon-check {
    margin-bottom: 20px;
    cursor: pointer;
}

.el-icon-edit {
    margin-bottom: 20px;
    cursor: pointer;
}
</style>
<template>
    <div>
        <!-- 到账填报抽屉 -->
        <el-drawer title="批量到账填报" :visible.sync="showArrive" :direction="direction" size="40%" :before-close="closeChage">
        <div class="drawer-inform">
            <div class="drawer-inform-div dw100">
                    <span class="inform-title">供应商: </span><span class="inform-content">{{
                        supplierName
                    }}</span>
                </div>
            </div>
            <div class="drawer-inform">
                <div class="drawer-inform-div">
                    <span class="inform-title">应付款: </span><span class="inform-content">{{ payTotal }}元</span>
                </div>
                <div class="drawer-inform-div">
                    <span class="inform-title">实际付款: </span><span class="inform-content">{{ receipTotal }}元</span>
                </div>
                <div class="drawer-inform-div">
                    <span class="inform-title">欠款: </span><span class="inform-content">{{ debtTotal }}元</span>
                </div>
            </div>
            <p class="t-left font-S16">付款信息</p>
            <div class="button-area pd0">
                <el-button size="medium" type="info" @click="arriveAdd()">新增</el-button>
            </div>
            <div class="payment-information" v-for="(item, index) in arriveData" :key="index">
                <div class="pay-left border-d6">
                    <div class="pay-item">
                        <div class="pay-name">到账款（元）：</div>
                        <el-input v-if="item.isEdit" class="ipt-sty" placeholder="请输入" type="text"
                            v-model="item.receiptAmount" :clearable="true"></el-input>
                        <div v-else>{{ item.receiptAmount | numDigit }}</div>
                    </div>
                    <div class="pay-item">
                        <div class="pay-name">到账日期：</div>
                        <el-date-picker v-if="item.isEdit" v-model="item.receiptDate" class="ipt-sty" type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                        <div v-else>{{ item.receiptDate | getDate }}</div>
                    </div>
                </div>
                <div class="pay-right">
                    <p class="fontC-409EFF c-pointer" @click="updateArriveDetail(item, index)">
                        {{ item.isEdit ? '保存' : '编辑' }}
                    </p>
                    <p class="fontC-red c-pointer" @click="deleteArriveDetail(item.guid)">删除</p>
                    <!-- <i class="el-icon-delete mb10" @click="deleteArriveDetail(item.guid)" title="删除"></i>
                                                                                                                                                                                                      <i :class="item.isEdit ? 'el-icon-check mb45' : 'el-icon-edit mb45'" :title="item.isEdit ? '保存' : '编辑'" @click="updateArriveDetail(item, index)"></i
                                                                                                                                                                                                      > -->
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
// import { reject } from 'lodash';
import { cloneDeep } from 'lodash';
export default {
    props: ['arrive'],
    data() {
        return {
            showArrive: false,
            arriveData: [],
            direction: 'rtl',
            batchArriveFillData: [],
            title: '',
            receiptAmount: 0
        };
    },
    watch: {
        arrive: {
            handler(newValue, oldValue) {
                console.log(newValue);
                this.batchArriveFillData = newValue;
            },
            deep: true,
        },
    },
    computed: {
        // 应付款
        payTotal() {
            return (this.batchArriveFillData.reduce((total, current) =>
                total + Number(current.payableAmount), 0)).toFixed(2);
        },
        // 实际付款
        receipTotal() {
            return (this.batchArriveFillData.reduce((total, current) =>
                total + Number(current.receiptAmount), 0) + this.receiptAmount).toFixed(2);
        },
        // 欠款
        debtTotal() {
            return ((this.batchArriveFillData.reduce((total, current) =>
                total + Number(current.payableAmount), 0)) - (this.batchArriveFillData.reduce((total, current) =>
                    total + Number(current.receiptAmount), 0) + this.receiptAmount)).toFixed(2)
        },
        supplierName() {
            return this.batchArriveFillData[0]?.supplierName
        }
    },
    created() {
        this.addIsEdit();
        console.log(this.arriveData);
    },
    methods: {
        //添加isedit
        addIsEdit() {
            let self = this;
            self.arriveData.forEach((item, index) => {
                item['isEdit'] = false;
            });
        },
        //对数据进行日期排序
        sortDataArray(dataArray) {
            const self = this;
            return dataArray.sort((a, b) => {
                return self.$moment(b.receiptDate).unix() - self.$moment(a.receiptDate).unix();
            });
        },
        //查询到账填报
        getArriveDetail(operatingCostsGuid) {
            let self = this;
            return new Promise((resolve, reject) => {
                self.api
                    .get(
                        `/${serverConfig.msDataBusinessService}/operating-receipt-amount/select-operating-receipt-amount-info?operatingCostsGuid=` +
                        operatingCostsGuid,
                    )
                    .then((res) => {
                        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                            self.arriveData = self.sortDataArray(res.data.data);
                            this.updateFund()
                            console.log(res.data.data);
                            console.log(self.arriveData);
                            resolve();
                        } else {
                            self.$message.error(res.data.msg);
                        }
                    });
            });
        },
        // 信息传递到主表
        updateToFill() {
            return new Promise((resolve, reject) => {
                let self = this;
                const receiptAmount = self.arriveData.reduce((total, current) => {
                    return total + current.receiptAmount;
                }, 0);
                let promise = {
                    guid: self.batchArriveFillData.guid,
                    medGuid: self.$store.state.medGuid,
                    supplierGuid: self.batchArriveFillData.supplierGuid,
                    receiptAmount: Number(receiptAmount),
                    paymentState: 'N',
                };
                console.log(receiptAmount);
                if (receiptAmount >= self.batchArriveFillData.payableAmount) {
                    promise.paymentState = 'Y';
                } else if (receiptAmount > 0 && receiptAmount < self.batchArriveFillData.payableAmount) {
                    promise.paymentState = 'P';
                } else {
                    promise.paymentState = 'N';
                }
                self.api.put(`/${serverConfig.msDataBusinessService}/operating-costs/update-operating-costs-list`, promise).then((res) => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        resolve();
                    } else {
                        self.$message.error(res.data.msg);
                    }
                });
            });
        },
        //更新到账信息
        updateFund() {
            this.batchArriveFillData.receiptAmount = this.arriveData.reduce((total, current) => {
                return total + Number(current.receiptAmount);
            }, 0);
        },
        // 抽屉关闭事件
        closeChage(done) {
            this.arriveData = []
            this.receiptAmount = 0
            done();
        },
        //新增或者修改到账填报
        updateArriveDetail(item, index) {
            let self = this;
            const flag = JSON.parse(JSON.stringify(self.arriveData));
            self.arriveData = flag;
            let promise = cloneDeep(self.batchArriveFillData).map(i => {
                i.receiptDate = item.receiptDate && self.$moment(item.receiptDate).format('YYYY-MM-DD');
                i.operatingCostsGuid = i.guid,
                    i.receiptAmount = item.receiptAmount;
                return i
            })
            console.log('00544', self.batchArriveFillData);
            // let promise = {
            //     guid: '',
            //     operatingCostsGuid: self.batchArriveFillData.guid,
            //     receiptDate: item.receiptDate && self.$moment(item.receiptDate).format('YYYY-MM-DD'),
            //     receiptAmount: item.receiptAmount,
            // };
            if (item.guid) {
                promise.guid = item.guid;
            } else {
                promise.guid = '';
            }
            self.receiptAmount = self.arriveData.reduce((total, current) => {
                return total + Number(current.receiptAmount);
            }, 0);
            // console.log(receiptAmount);
            // if (receiptAmount > self.batchArriveFillData.payableAmount) {
            //   self.$message.error('到账总金额不能大于应付总金额！');
            //   return;
            // } else if (item.receiptAmount <= 0) {
            //   self.$message.error('到账金额必须大于0！');
            //   return;
            // }
            if (item.receiptAmount <= 0) {
                self.$message.error('到账金额必须大于0！');
                return;
            }
            if (flag[index].isEdit) {
                if (item.receiptAmount == '') {
                    self.$message.error('请输入到账款！');
                    return;
                } else if (item.receiptDate == '' || item.receiptDate == null) {
                    self.$message.error('请选择到账日期！');
                    return;
                } else {
                    self.api
                        .postJson(
                            `/${serverConfig.msDataBusinessService}/operating-receipt-amount/insert-or-update-operating-receipt-amount`,
                            promise,
                        )
                        .then(async (res) => {
                            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                                // await self.getArriveDetail(self.batchArriveFillData.guid);
                                self.$emit('refreshData');
                                // self.updateToFill().then(function () {
                                //     self.$emit('refreshData');
                                // });
                                flag[index].isEdit = false;
                                self.$message.success('保存成功!');
                                // this.showArrive = false
                            } else {
                                self.$message.error(res.data.msg);
                            }
                        });
                }
            } else {
                const isEdit = flag.some((item) => item.isEdit);
                if (isEdit) {
                    self.$message.error('请先保存已编辑的数据!');
                } else {
                    flag[index].isEdit = true;
                }
            }
        },
        //新增
        arriveAdd() {
            let self = this;
            const isEdit = self.arriveData.some((item) => item.isEdit);
            if (isEdit) {
                self.$message.error('请先保存已编辑的数据!');
            } else {
                let newArrive = {
                    receiptAmount: '',
                    receiptDate: '',
                    isEdit: true,
                };
                self.arriveData.unshift(newArrive);
            }
        },
        //删除到账填报接口
        deleteArriveDetail(guid) {
            let self = this;
            self.api
                .postJson(
                    `/${serverConfig.msDataBusinessService}/operating-receipt-amount/delete-operating-receipt-amount?guid=` +
                    guid,
                )
                .then(async (res) => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        self.$message.success('删除成功！');
                        await self.getArriveDetail(self.batchArriveFillData.guid);
                        self.$emit('refreshData');
                        // self.updateToFill().then(function () {
                        //     self.$emit('refreshData');
                        // });
                    } else {
                        self.$message.error(res.data.msg);
                    }
                });
        },
    },
};
</script>